import { render, staticRenderFns } from "./WorkQuestionDialog.vue?vue&type=template&id=0c201a42"
import script from "./WorkQuestionDialog.vue?vue&type=script&lang=js"
export * from "./WorkQuestionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports